

import { Layout, Row, Col } from "antd";
import { HeartFilled } from "@ant-design/icons";
import { SECONDARY_COLOR } from "../../utils/colors";

function Footer() {
  const { Footer: AntFooter } = Layout;

  return (
    <AntFooter style={{ background: "transparent" }}>
      <Row className="just">
        <Col xs={24} md={12} lg={12}>
          <div className="copyright">
            © 2024, <span style={{ color: SECONDARY_COLOR }}> Equity Group Foundation</span>
            
          </div>
        </Col>
        
      </Row>
    </AntFooter>
  );
}

export default Footer;
